import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import ErrorBoundary from 'components/ErrorBoundary'
import Slider from 'components/Slider'
import Info from 'components/Info'

const defaultAvailability = [[8,16]]
const week = [
    {
        label: 'Monday',
        shortName: 'mo',
        min: 0,
        max: 24,
    },
    {
        label: 'Tuesday',
        shortName: 'tu',
        min: 0,
        max: 24,
    },
    {
        label: 'Wednesday',
        shortName: 'we',
        min: 0,
        max: 24,
    },
    {
        label: 'Thursday',
        shortName: 'th',
        min: 0,
        max: 24,
    },
    {
        label: 'Friday',
        shortName: 'fr',
        min: 0,
        max: 24,
    },
    {
        label: 'Saturday',
        shortName: 'sa',
        min: 0,
        max: 24,
    },
    {
        label: 'Sunday',
        shortName: 'su',
        min: 0,
        max: 24,
    },
]

class WorkingHours extends Component{

    setAvailability = (payload) =>  {
        const { day, values, active } = payload
        this.props.onChange({
            day: day,
            time: {'time': [values]},
            active
        })
    }

    render(){
        
        const { times: { days }, days: workDays, children } = this.props

        return(
            <div className="fieldset-wrap" id="hours">
                <fieldset className="fieldset">
                    <legend className="legend">
                        <div className="form-group form-group__legend form-group__with-info info__pin-right">
                            2. Hours<br />
                            <small>Setup your default working hours for Birdietime.</small>
                            <Info className="info__pin-right">
                                The default working hours can be changed later.
                                You can also easily block times from your calendar, so it's better to have more than less open times.
                            </Info>
                        </div>
                    </legend>
                    <Row className="form--row">
                        <Col xs={12}>
                            <div className="form-group">
                            {
                                week.map(day => (
                                    <ErrorBoundary key={day.label}>
                                        <Slider
                                            label={day.label}
                                            value={days[day.shortName].time[0]}
                                            active={workDays[day.shortName]}
                                            min={day.min}
                                            max={day.max}
                                            day={day.shortName}
                                            onChange={this.setAvailability}
                                        />
                                    </ErrorBoundary>
                                ))
                            }
                            </div>
                        </Col>
                    </Row>
                    { children }
                </fieldset>
            </div>
        )
    }
}

WorkingHours.defaultProps = {
    availabilities : {
        location_id: null, 
        repeat: 2, 
        type: 0,
        days: {
            su: { time: defaultAvailability },
            mo: { time: defaultAvailability },
            tu: { time: defaultAvailability },
            we: { time: defaultAvailability },
            th: { time: defaultAvailability },
            fr: { time: defaultAvailability },
            sa: { time: defaultAvailability },
        }
    }
}

export default WorkingHours


// WEBPACK FOOTER //
// ./src/components/WorkingHours/WorkingHours.js